import './index.css';

const NotFound = () => {
  return (
    <div className="container not-found-container">
      <div className="row">
        <div className="col-12 text-center">
          <div className="title-not-found"> Whooppsiie!</div>
          <div className="sub-title-nf"> - Sorry, Page Not Found - </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
